import { scenePlugins } from '@ff-os/pdp-shared-registry/index';
import { Pdp } from '@ff-os/pdp-shared-registry/Pdp';
import { logError } from '@ff-os/shared-utils/logging';
import { actions as snapshotActions } from '../slices/snapshotSlice';
import { AppThunkApi } from '../store';
import { externalUploadPoller } from './external-upload/externalUploaderPoller';
import { loadExternalUploaders } from './external-upload/loadExternalUploaders';
import { tryPollExternalUploads } from './external-upload/tryPollExternalUploads';

export const openProject = async (
    thunkApi: AppThunkApi,
    pluginId: string,
    { design, savedOn }: { design: any; savedOn: number },
    isCompatible: boolean,
    source: Pdp.Scene.ProjectSource
) => {
    try {

        const plugin = scenePlugins.require(pluginId);
        const result = await plugin.project.open(
            design, isCompatible, source, thunkApi.dispatch, thunkApi.getState);

        if (result.continue) {
            thunkApi.dispatch(snapshotActions.initialize({ savedOn }));
            await loadAndSyncExternalUploads(thunkApi);
        }

        return result;

    } catch (e) {
        logError(e);
        throw e;
    }
};

// Ensures new uploads are added before user interaction is possible
const loadAndSyncExternalUploads = async (
    { dispatch, getState }: AppThunkApi
) => {

    await dispatch(loadExternalUploaders());
    const state = getState();

    externalUploadPoller.updatedOn = state.snapshot.savedOn ?? Date.now();

    await tryPollExternalUploads(state, dispatch);
};